import React from 'react';
import { PropTypes } from 'prop-types';
import formatDate from 'common/utils/Dates/formatDate';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';
import { getTimelineAssignmentMessage } from 'common/Workqueue/timelineEventUtils';

const ServiceAuthorizationAssignmentEvent = ({ timelineEvent }) => {
  const icon = 'IconUserCircle';
  const message = getTimelineAssignmentMessage(timelineEvent);
  const date = formatDate(timelineEvent.timestamp);

  const formattedTimelineEvent = {
    icon,
    message,
    date,
  };

  return (
    <BaseTimelineEvent {...formattedTimelineEvent} />
  );
};

ServiceAuthorizationAssignmentEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default ServiceAuthorizationAssignmentEvent;
